// Global Instructions Rule Applied!
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTrash } from '@fortawesome/free-solid-svg-icons'
import { Popconfirm, Button as AntButton } from 'antd'
import { URL_TYPE } from '../../../../state_manager/constants/files.ts'

interface FileActionsProps {
  record: {
    key: string
    type: typeof URL_TYPE | 'file'
  }
  deletingRowKey: string | null
  onRemove: (key: string) => void
}

const FileActions = ({ record, deletingRowKey, onRemove }: FileActionsProps) => {
  const isDeleting = deletingRowKey === record.key
  const itemType = record.type === URL_TYPE ? 'URL' : 'file'
  const deleteTitle = `Delete ${itemType}`
  const deleteDescription = `Are you sure you want to remove this ${itemType.toLowerCase()}?`

  return (
    <Popconfirm
      title={deleteTitle}
      description={deleteDescription}
      okText='Yes, Delete'
      cancelText='Cancel'
      okType='danger'
      placement='topRight'
      onConfirm={() => onRemove(record.key)}
      okButtonProps={{ loading: isDeleting }}
      cancelButtonProps={{ disabled: isDeleting }}
      disabled={isDeleting}
    >
      <AntButton
        type='text'
        size='small'
        danger
        icon={<FontAwesomeIcon icon={faTrash} className='text-xs' />}
        loading={isDeleting}
        disabled={isDeleting}
      />
    </Popconfirm>
  )
}

export default FileActions
